module.exports = __webpack_public_path__ + "img/dk.6faa90be.svg";